import React from 'react';
import uniqid from 'uniqid';

import AccordionItem from 'components/partials/accordion/accordion-item/accordion-item';

interface AccordionItemData {
  name: string;
  description: string;
}

interface AccordionProps {
  items: AccordionItemData[];
  customClass?: string;
}

const Accordion = ({
  items,
  customClass = '',
}: AccordionProps): React.JSX.Element => (
  <div role="list" className={`flex flex-col gap-2 ${customClass}`}>
    {items?.map((item, index) => (
      <AccordionItem
        key={uniqid()}
        index={index}
        name={item.name}
        description={item.description}
        role="listitem"
      />
    ))}
  </div>
);

export default Accordion;
